module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First published in Great Britain in 2019 by Polygon, an imprint of Birlinn Ltd,")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("West Newington House,"), _c('br'), _vm._v("10 Newington Road,"), _c('br'), _vm._v("Edinburgh"), _c('br'), _vm._v("EH9 1QS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.polygonbooks.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.polygonbooks.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © Angus McAllister, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A short story entitled ‘The List’, which included material from this book, was published in the online version of "), _c('em', [_vm._v("The Strand Magazine")]), _vm._v(" in 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The right of Angus McAllister to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This is a work of fiction. Names, characters, businesses, places, events and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978 1 84697 471 7"), _c('br'), _vm._v("eBook ISBN 978 1 78885 174 9")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("British Library Cataloguing-in-Publication Data")]), _c('br'), _vm._v("A catalogue record for this book is available on request from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Typeset by "), _c('a', {
    attrs: {
      "href": "http://3btype.com",
      "target": "_blank"
    }
  }, [_vm._v("3btype.com")]), _vm._v(", Rosyth")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0